import { render, staticRenderFns } from "./FechamentoLinhas.vue?vue&type=template&id=004de048&scoped=true&"
import script from "./FechamentoLinhas.vue?vue&type=script&lang=js&"
export * from "./FechamentoLinhas.vue?vue&type=script&lang=js&"
import style0 from "./FechamentoLinhas.vue?vue&type=style&index=0&id=004de048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004de048",
  null
  
)

export default component.exports